
import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import PageHeader from '@/components/base/PageHeader.vue'

type ProjectOption = { id: number, name: string, reference?: string, city?: string }
type SelectOptionNode = { componentOptions?: { children?: Array<{ text?: string }> } }

@Component({ components: { PageHeader } })
export default class KAMFormCreate extends Vue {
  projects: ProjectOption[] = []
  loadingProjects = false
  saving = false

  form = {
    project_id: null as number|null,
    externalClient: false,
    projectName: '',
    projectReference: '',
    projectLocation: ''
  }

  get selectedTemplate (): { id: number, reference: string, name: string, version: number } {
    return { id: 7, reference: 'KAM005', name: 'KAM005 - VGM-plan', version: 1 }
  }

  mounted (): void {
    this.loadProjects()
  }

  async loadProjects (): Promise<void> {
    this.loadingProjects = true
    try {
      const response = await axios.get(`${process.env.VUE_APP_API_URL}/kamForms/projects`)
      this.projects = response.data || []
    } catch {
      notification.error({ message: 'Projecten konden niet worden geladen.', description: 'Probeer het later opnieuw.', duration: 3 })
    } finally {
      this.loadingProjects = false
    }
  }

  selectedProject (): ProjectOption|undefined {
    return this.projects.find(project => project.id === this.form.project_id)
  }

  syncProjectDefaults (): void {
    const project = this.selectedProject()
    this.form.projectName = project?.name || ''
    this.form.projectReference = project?.reference || ''
    this.form.projectLocation = project?.city || ''
  }

  today (): string {
    return new Date().toISOString().slice(0, 10)
  }

  filterProjects (input: string, option: SelectOptionNode): boolean {
    const label = String(option?.componentOptions?.children?.map(child => child.text || '').join('') || '').toLowerCase()
    return label.includes(input.toLowerCase())
  }

  async create (): Promise<void> {
    if (!this.form.project_id) return
    this.saving = true
    try {
      const created = await axios.post(`${process.env.VUE_APP_API_URL}/kamForms`, {
        form_template_id: this.selectedTemplate.id,
        form_reference: this.selectedTemplate.reference,
        form_name: 'VGM-plan',
        form_version: this.selectedTemplate.version,
        project_id: this.form.project_id
      })

      const item = created.data.data
      const answers: Record<string, string|number|boolean|null> = {
        externalClient: this.form.externalClient,
        projectName: this.form.projectName,
        projectReference: this.form.projectReference,
        projectLocation: this.form.projectLocation,
        createdDate: this.today(),
        updatedDate: this.today()
      }
      await axios.put(`${process.env.VUE_APP_API_URL}/kamForms/${item.id}`, { answers, status: item.status })
      notification.success({ message: 'VGM-plan aangemaakt.', description: 'Het formulier wordt geopend.', duration: 3 })
      this.$router.push({ name: 'kamFormEdit', params: { kamFormId: String(item.id), formReference: this.selectedTemplate.reference } })
    } catch {
      notification.error({ message: 'VGM-plan kon niet worden aangemaakt.', description: 'Controleer het project en probeer opnieuw.', duration: 3 })
    } finally {
      this.saving = false
    }
  }
}
